import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// --- CHANGE 1: Import the main application stylesheet ---
// This tells Vite to bundle and load all your project's CSS.
import '../../assets/stylesheets/application.tailwind.css';

// --- CHANGE 2: Corrected the component name to match the export ---
import Home from '../components/Home';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      {/* We can remove the extra div here as it's not strictly necessary */}
      <Home />
    </BrowserRouter>
  );
}